// extracted by mini-css-extract-plugin
export default {"cards_container":"OrderCardList_cards_container__-bD1F","order_date":"OrderCardList_order_date__Ezy7L"};